import React from 'react';
import { useSelector } from 'react-redux';
import {
  SharedTemplateAboutModal,
  SharedTemplateDeleteModal,
  SharedTemplateDuplicateModal,
  SharedTemplateEditModal,
  SharedTemplateSaveModal,
  SharedTemplateShareModal,
  SharedTemplateTriOptionModal,
  SharedTemplateUnsavedModal,
} from '../presentational/sharedTemplateComponents';

const VolumeTrackerTemplateModals = () => {
  const vtAboutModalShowing = useSelector(
    (state) => state.volumeTrackerDashboard.ui.aboutModalShowing,
  );
  const vtDeleteModalShowing = useSelector(
    (state) => state.volumeTrackerDashboard.ui.deleteModalShowing,
  );
  const vtDuplicateModalShowing = useSelector(
    (state) => state.volumeTrackerDashboard.ui.duplicateModalShowing,
  );
  const vtEditModalShowing = useSelector(
    (state) => state.volumeTrackerDashboard.ui.editModalShowing,
  );
  const vtOptionModalShowing = useSelector(
    (state) => state.volumeTrackerDashboard.ui.optionModalShowing,
  );
  const vtSaveModalShowing = useSelector(
    (state) => state.volumeTrackerDashboard.ui.saveModalShowing,
  );
  const vtShareModalShowing = useSelector(
    (state) => state.volumeTrackerDashboard.ui.shareModalShowing,
  );
  const unsavedVTDashModalShowing = useSelector(
    (state) => state.volumeTrackerDashboard.ui.unsavedModalShowing,
  );
  return (
    <>
      {vtAboutModalShowing && (
        <SharedTemplateAboutModal
          dashboard='Volume Tracker'
          legacyName='Volume Tracker'
        />
      )}
      {vtDeleteModalShowing && (
        <SharedTemplateDeleteModal
          dashboard='Volume Tracker'
          legacyName='Volume Tracker'
        />
      )}
      {vtDuplicateModalShowing && (
        <SharedTemplateDuplicateModal
          dashboard='Volume Tracker'
          legacyName='Volume Tracker'
        />
      )}
      {vtEditModalShowing && (
        <SharedTemplateEditModal
          dashboard='Volume Tracker'
          legacyName='Volume Tracker'
        />
      )}
      {vtSaveModalShowing && (
        <SharedTemplateSaveModal
          dashboard='Volume Tracker'
          legacyName='Volume Tracker'
        />
      )}
      {vtShareModalShowing && (
        <SharedTemplateShareModal
          dashboard='Volume Tracker'
          legacyName='Volume Tracker'
        />
      )}
      {vtOptionModalShowing && (
        <SharedTemplateTriOptionModal
          dashboard='Volume Tracker'
          legacyName='Volume Tracker'
        />
      )}
      {unsavedVTDashModalShowing && (
        <SharedTemplateUnsavedModal
          dashboard='Volume Tracker'
          legacyName='Volume Tracker'
        />
      )}
    </>
  );
};

export default VolumeTrackerTemplateModals;
